import { ShippingOptions, ReviewsSection, DarkCTA } from "@/components/Sections";
import { MotoHero, MotoPerks, MotoWhat, MotoSteps, MotoPrep, MotoOffers, MotoFaq } from "@/components/MotoSections";

export default function SpedizioneMoto() {
  return (
    <>
      <MotoHero />
      <MotoPerks />
      <MotoWhat />
      <MotoSteps />
      <ShippingOptions servizio="moto" />
      <MotoPrep />
      <MotoOffers />
      <ReviewsSection />
      <MotoFaq />
      <DarkCTA />
    </>
  );
}
